import { withStyles } from '@material-ui/styles';
import React from 'react';

import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import PageNotFoundStyles from 'pages/pagenotfound/PageNotFoundStyles';

interface Props {
  classes?: any;
}

const NoAcessUser: React.FC<Props> = ({ classes }) => {
  return (
    <div className={classes.pnfContent}>
      <InfoRoundedIcon className={classes.pnfIcon} />

      <span className={classes.pnfTxt}>
        Sorry, you don&apos;t have access to the available films yet, please
        speak to the responsible teacher for your institution.
      </span>
    </div>
  );
};

export default withStyles(PageNotFoundStyles)(NoAcessUser);
